/*
 * @Author: Yun
 * @Date: 2023-11-29 12:44:29
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-01 11:29:41
 */
import React, { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import Loading from '@components/loading'
import FirstPage from '@components/pc/firstPage'
import WelcomePage from '@components/pc/welcome'
import HotwordsPage from '@components/pc/hotwords'
import IntroPage from '@components/pc/intro'
import CongressPage from '@components/pc/congress'
import SubmissionPage from '@components/pc/submission'
import SummaryPage from '@components/pc/summary'
import Footer from '@components/pc/footer'
import './index.less'

const PREFIX = 'twosession-pc'

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

const PcPage = (props) => {
    useEffect(() => {
        let tl1 = null
        tl1 = animation1()
        handleAddLabel(tl1)
        window.addEventListener('resize', () => {
            tl1.scrollTrigger.update()
        })
    }, [])

    const animation1 = () => {
        return gsap.timeline({
            // 添加到整个时间线
            scrollTrigger: {
                trigger: '#pc_home',
                // markers: true,
                pin: true, // 在执行时固定触发器元素
                start: `top top`, // 当触发器的顶部碰到视口的顶部时
                end: '+=12000', // 在滚动 2000 px后结束
                scrub: 1, // 触发器1秒后跟上滚动条，使动画绑定滚动事件
                fastScrollEnd: true,
                invalidateOnRefresh: true,
                // snap: {
                //     snapTo: 0.02,
                //     duration: 1,
                //     ease: 'power1.inOut',
                // },
            },
        })
    }

    const handleAddLabel = (tl) => {
        if (tl) {
            let activeRoute = document.querySelector('.submission-page-timeline-line').offsetWidth
            // 向时间线添加动画和标签
            return tl
                .addLabel('start')
                .to(`.welcome-page`, { yPercent: -100, duration: 5, delay: 5 })
                .addLabel('act1')
                .to(`.welcome-page-person`, { xPercent: -100, duration: 5, delay: 0 }, '<')
                .to(`.welcome-page-person`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.welcome-page-txt`, { opacity: 1, duration: 6, delay: 2 }, '<')
                .addLabel('act2')
                .to(`.hotwords-page`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .addLabel('act3')
                .to(`.intro-page`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .addLabel('act4')
                .to(`.intro-page-person`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.intro-page-top`, { xPercent: 100, duration: 5, delay: 2 }, '<')
                .to(`.intro-page-top`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.intro-page-iconvideo`, { display: 'block', duration: 0, delay: 0 }, '>')
                .to(`.intro-page-iconvideo`, { opacity: 1, duration: 2, delay: 0 }, '>')
                .addLabel('act5')
                .to(`.congress-page`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .addLabel('act6')
                .to(`.congress-page-img1`, { xPercent: 100, duration: 5, delay: 1 }, '<')
                .to(`.congress-page-img1`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.congress-page-img2`, { xPercent: -100, duration: 5, delay: 2 }, '<')
                .to(`.congress-page-img2`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.congress-page-img3`, { xPercent: 100, duration: 5, delay: 3 }, '<')
                .to(`.congress-page-img3`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .to(`.congress-page-img4`, { xPercent: -100, duration: 5, delay: 4 }, '<')
                .to(`.congress-page-img4`, { opacity: 1, duration: 7, delay: 2 }, '<')
                .addLabel('act7')
                .to(`.submission-page`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .to(`.submission-page-iconvideo1`, { display: 'block', duration: 0, delay: 0 }, '>')
                .to(`.submission-page-iconvideo1`, { opacity: 1, duration: 2, delay: 0 }, '>')
                .addLabel('act8')
                .to(`.submission-page-person1`, { opacity: 0, duration: 5, delay: 5 }, '>')
                .to(`.submission-page-person2`, { xPercent: -100, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-person2`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon1`, { opacity: 0, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon1`, { xPercent: 100, duration: 5, delay: 0 }, '<')
                .to(
                    `.submission-page-timeline-active`,
                    {
                        x: activeRoute * (window.innerWidth > 498 ? 0.49 : 0.49),
                        duration: 5,
                        delay: 0,
                    },
                    '<'
                )
                .to(`.submission-page-img1`, { opacity: 0, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-item1`, { display: 'none', duration: 3, delay: 0 }, '<')
                .to(`.submission-page-item2`, { display: 'block', duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon2`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-img2`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .addLabel('act9')
                .to(`.submission-page-person2`, { opacity: 0, duration: 5, delay: 5 }, '>')
                .to(`.submission-page-person3`, { xPercent: -100, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-person3`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon2`, { opacity: 0, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon2`, { xPercent: 100, duration: 5, delay: 0 }, '<')
                .to(
                    `.submission-page-timeline-active`,
                    {
                        x: activeRoute * (window.innerWidth > 498 ? 0.95 : 0.95),
                        duration: 5,
                        delay: 0,
                    },
                    '<'
                )
                .to(`.submission-page-img2`, { opacity: 0, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-item2`, { display: 'none', duration: 3, delay: 0 }, '<')
                .to(`.submission-page-item3`, { display: 'block', duration: 5, delay: 0 }, '<')
                .to(`.submission-page-icon3`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .to(`.submission-page-img3`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .addLabel('act10')
                .to(`.summary-page`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .to(`.summary-page-tv`, { xPercent: -100, duration: 5, delay: 0 }, '>')
                .to(`.summary-page-tv`, { opacity: 1, duration: 5, delay: 0 }, '<')
                .addLabel('act11')
                .to(`.footer`, { yPercent: -100, duration: 5, delay: 5 }, '>')
                .addLabel('end')
        }
    }

    const onNext = () => {
        gsap.to(window, {
            scrollTo: {
                duration: 5,
                y: '#congress-page',
            },
        })
    }

    return (
        <div className={PREFIX}>
            <Loading />
            <div className={`${PREFIX}-bg`}>
                <div className={`${PREFIX}-wrapper`}>
                    <section className={`${PREFIX}-home`} id="pc_home">
                        <FirstPage />
                        <WelcomePage />
                        <HotwordsPage />
                        <IntroPage onNext={onNext} />
                        <CongressPage id={'congress-page'} />
                        <SubmissionPage />
                        <SummaryPage />
                        <Footer />
                    </section>
                </div>
            </div>
        </div>
    )
}

export default PcPage
